<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/32Ax2B/tc-custom/9781468307870.jpg?1720281562526" alt="This image is the cover for the book Don't Point That Thing at Me, The Charlie Mortdecai Mystery Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Don't Point That Thing at Me, The Charlie Mortdecai Mystery Series
      </h1>
      <p class="bookDescription body article font2">
        <b>This witty crime thriller series debut follows the exploits of an unscrupulous art dealer with a stolen Goya—“this cult classic . . . is a true original” (<i>Booklist</i>, starred review).</b><br/><br/>In <i>Don't Point that Thing at Me</i>, British author and art dealer Kyril Bonifiglioli introduced the Honorable Charlie Mortdecai: degenerate aristocrat, amoral art dealer, seasoned epicurean, unwilling assassin, and general knave-about-Piccadilly. Since its publication in the 1970s, this dark humored crime thriller has earned its place as a beloved cult classic. <br/><br/>With his thuggish manservant Jock, Mortdecai endures all manner of nastiness involving secret police, angry foreign governments, stolen paintings, and dead clients, all just to make a dishonest living—while decked out in the most stylish garb and drinking the most bizarre alcoholic cocktails. Don’t miss the brilliant mixture of comedy, crime, and suspense.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kyril Bonfiglioli
      </h2>
      
      <p class="authorDescription body article">Kyril Bonfiglioli (1928 – 1985) was an art dealer, accomplished fencer, a fair shot with most weapons, and a serial marrier of beautiful women. He claimed to be “abstemious in all things except drink, food, tobacco, and talking,” and “loved and respected by all who knew him slightly.”</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ef5cc87